import clsx from "clsx";
import React, { FunctionComponent, useEffect, useRef } from "react";

import { compareActionPrint } from "../blocks/LeadForm/LeadFormCompare";
import { Meta } from "../blocks/Meta/Meta";
import { TireComparisonGrid } from "../blocks/Tires/TiresCompareDialog/TireComparisonGrid";
import { config } from "../config/config";
import { DealerComparePrintRoute } from "../navigation/DealerRoutes";
import { useRouteParams } from "../navigation/useRouteParams";
import { useBuildComparison } from "../queries/useBuildComparison";
import { useDealerAddress } from "../stores/hooks/useDealerAddress";
import { useNullableDealerAccountInfo } from "../stores/hooks/useNullableDealerAccountInfo";
import { useUrl } from "../stores/hooks/useUrl";

export const DealerComparePrintPage: FunctionComponent = () => {
  const ref = useRef<HTMLElement>(null);
  const params = useRouteParams(DealerComparePrintRoute);
  const { hash } = useUrl();
  const compareIds = params?.partId.split(",") || [];
  const { data } = useBuildComparison(compareIds);

  const cacheKey = data
    ?.flat()
    .map(({ part }) => part.partDetails.primaryPart.itemId)
    .join(",");

  useEffect(() => {
    if (data && hash === compareActionPrint) {
      window.print();
    }
  }, [cacheKey]);

  const { Logo } = config;
  const { dealerContactEmail, dealerContactPhone, dealerName } =
    useNullableDealerAccountInfo() ?? {};
  const deaalerAddress = useDealerAddress();

  const entries = [
    dealerName,
    deaalerAddress,
    dealerContactPhone,
    dealerContactEmail,
  ];

  return (
    <>
      <Meta cmsTitle={null} title="dealerComparePrintPage" />
      <main
        className={clsx(
          "max-w-[11in] w-full mx-auto px-8 py-12 print:px-0 print:py-0 bg-white text-xs",
          "shadow-xl print:shadow-none rounded-sm",
          "min-h-screen",
        )}
        ref={ref}
      >
        <header className="border-b border-b-edge mb-4 flex items-center justify-between pb-2">
          <Logo />
          <div className="text-right">
            {entries.map((entry) => (
              <div key={entry}>{entry}</div>
            ))}
          </div>
        </header>
        <TireComparisonGrid compareIds={compareIds} printMode />
      </main>
    </>
  );
};
